import { ServicesList } from './pages/ServicesList';
import { ServicesForm } from './pages/ServicesForm';

export const ServicesRoutes = [
  {
    path: '/servicos',
    exact: true,
    component: ServicesList,
  },
  {
    path: '/servicos/novo',
    exact: true,
    component: ServicesForm,
  },
  {
    path: '/servicos/edit/:id',
    exact: true,
    component: ServicesForm,
  },
];
